import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';
import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'
import Container from 'react-bootstrap/Container'

import APIS from "../../../utils/APIS"

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import loadingGIF from '../../../images/loadingGIF.gif'


const EcoleResults = () => {
  const navigate = useNavigate()
  const params = useParams();

  const { ecoles } = useContext(SuperAdminContext)

  const [ecole, setEcole] = useState(null)

  const setActEcole = () => {
    var findEcole = ecoles?.find((l) => l.id.toString() == params?.id)

    if (findEcole) {
      //if (ecole == null) {
        setEcole(findEcole)
      //}
    } else {
      navigate("/admin/ecoles")
    }
  }

  useEffect(() => {
    if (params?.id && ecoles) {
      setActEcole()
    }
  }, [ecoles, ecole, params])


  const [allGroupes, setAllGroupes] = useState([])
  useEffect(() => {
    //console.log("au chargement on va chercher tous les groupes même archivés")
    let vals = {archived : true}
    APIS.getSuperAdminGroupes({archived:true}).then((results) => {
      setAllGroupes(results)
    })
  }, [])

  const [loaded, setLoaded] = useState(false)
  const [datas, setDatas] = useState([])

  const initFct = () => {
    if (loaded === false && ecole && allGroupes.length > 0) {
      let fetchData = []
      let groupesData = []
      ecole?.groupes?.forEach((groupe) => {
        let g = allGroupes?.find((el) => el.id === groupe.groupeID)
        if (g) {
          g.plan = JSON.parse(g.plan)
          if (g.icebreaker !== null) {
            let ids = []
            if (g?.icebreaker) {
              ids.push(g?.icebreaker)
            }
            g?.plan?.plan?.forEach((p) => {
              ids.push(p.id)
            })
            fetchData.push({
              groupeID : g.id,
              ids : ids,
              icebreaker : g.icebreaker
            })
            groupesData.push({
              groupeID : g.id,
              ids : ids,
              icebreaker : g.icebreaker,
              plan : g.plan,
              name : g.name,
            })
          }
        }
      })

      if (fetchData.length > 0) {
        APIS.clientAdminSuivi({fetchData : fetchData}).then((result) => {
          if (result?.value?.length > 0) {
            //console.log(res?.data?.value)
            //on va calculer les datas par groupes
            let maxValuesNbr = 0;
            groupesData.forEach((groupe) => {
              let findResponse = result?.value?.find((el) => el.groupeID === groupe.groupeID)
              if (findResponse) {
                let values = []
                //console.log(groupe)
                //engagement
                //console.log(findResponse)
                let nbrDejaConnecte = findResponse?.users?.filter((el) => {
                  if (el.lastConnection === null) {
                    let findInProgress = findResponse?.results?.find((el2) => el2.userID === el.id && el2.progress > 0)
                    if (findInProgress) {
                      return true
                    } else {
                      return false
                    }
                  } else {
                    return true
                  }
                })?.length
                groupe.nbrUsersTotal = findResponse?.users?.length
                let tauxEngagement = (nbrDejaConnecte / findResponse?.users?.length) * 100
                values[0] = {nbr : nbrDejaConnecte, label : Math.round(tauxEngagement * 100) / 100}
                //icebreaker
                let indexValues = 1
                let nbrTermine = findResponse?.results?.filter((el) => el.contentID === groupe?.icebreaker && el.progress === 100 && el.isDone === true)?.length
                let percent = (nbrTermine / values[indexValues-1]?.nbr) * 100
                values[indexValues] = {nbr : nbrTermine, label : Math.round(percent * 100) / 100}
                //modules
                groupe?.plan?.plan?.forEach((formation, index) => {
                  let indexValues = 2+index
                  let nbrTermine = findResponse?.results?.filter((el) => el.contentID === formation.id && el.progress === 100 && el.isDone === true)?.length
                  let percent = 0
                  if (values[indexValues-1]?.nbr !== 0) {
                    percent = (nbrTermine / values[indexValues-1]?.nbr) * 100
                  }
                  values[indexValues] = {nbr : nbrTermine, label : Math.round(percent * 100) / 100}
                })
                groupe.values = values
                if (values.length > maxValuesNbr) {
                  maxValuesNbr = values.length
                }
              }
            })

            //on s'occupe du total
            let nbrUsersTotal = 0
            let nbrs = []
            groupesData.forEach((g) => {
              nbrUsersTotal += g.nbrUsersTotal
              for (let i=0; i<maxValuesNbr; i++) {
                if (nbrs[i]) {
                  nbrs[i] += g.values[i]?.nbr
                } else {
                  nbrs[i] = g.values[i]?.nbr
                }
              }
            })

            let glbValues = []
            nbrs.forEach((nbr, index) => {
              if (!isNaN(nbr)) {
                if (index === 0) {
                  let percent = (nbr / nbrUsersTotal) * 100
                  glbValues.push({nbr : nbr, label : Math.round(percent * 100) / 100})
                } else {
                  let percent = 0
                  if (nbrs[index-1] !== 0) {
                    percent = (nbr / nbrs[index-1]) * 100
                  }
                  glbValues.push({nbr : nbr, label : Math.round(percent * 100) / 100})
                }
              }
            })

            let totalData = {
              nbrUsersTotal : nbrUsersTotal,
              values : glbValues
            }

            setDatas({groupes : groupesData, maxValuesNbr : maxValuesNbr, totalData : totalData})
            setLoaded(true)
          }
        })
      } else {
        alert("Erreur")
      }

    }
  }


  useEffect(() => {
    initFct()
  }, [ecole, loaded, allGroupes])


  const getColumnsNames = (index, maxLength) => {
    let texte = ""
    if (index === 0) {
      texte = "Taux d'activation"
    } else if (index === 1) {
      texte = "Taux de lancement"
    } else if (index === (maxLength - 1)) {
      texte = "Taux de rétention"
    } else {
      texte = "Taux d'engagement"
    }
    return texte
  }


  return (
    <>
      <Helmet>
        <title>Admin Ecoles | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            withBack="/admin/ecoles"
            title="Retour aux écoles"
          >
          </TopBar>


          {ecole !== null && (
            <Box sx={{ padding:"0px 10px" }}>
              <Box>
                <Box>École : {ecole?.name}</Box>
              </Box>

              <Box sx={{display:"flex", overflowX:"auto", overflowY:"hidden", padding:"10px 0px"}}>
                <Container style={{minWidth:'800px', width:'100%'}}>
                  {(loaded === true && datas?.groupes) ? (
                    <Table style={{margin:'auto', width:'100%'}}>
                      <thead>
                        <tr style={{height:'30px', fontSize:"18px", fontWeight:"bold"}}>
                          <th>
                            Groupe
                          </th>
                          {[...Array(datas?.maxValuesNbr)].map((x, i) =>
                            <th key={i}>
                              {getColumnsNames(i, datas?.maxValuesNbr)}
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                      <tr style={{height:'30px', backgroundColor : '#F3F3F3'}}>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          TOTAL ({datas?.totalData?.nbrUsersTotal})
                        </td>
                        {[...Array(datas?.maxValuesNbr)].map((x, i) => {
                          if (datas?.totalData?.values[i]) {
                            return (
                              <td key={i} style={{verticalAlign:"middle", textAlign:"center"}}>
                                {datas?.totalData?.values[i]?.label+" %"} ({datas?.totalData?.values[i]?.nbr})
                              </td>
                            )
                          } else {
                            return (
                              <td key={i} style={{verticalAlign:"middle", textAlign:"center"}}>
                                -
                              </td>
                            )
                          }
                        })}
                      </tr>
                        {datas?.groupes.map((g, index) => {
                          return (
                            <tr key={index} style={{height:'30px', backgroundColor : index%2 == 0 ? 'white' : '#F3F3F3'}}>
                              <td style={{verticalAlign:"middle", textAlign:"center"}}>
                                {g.name} ({g.nbrUsersTotal})
                              </td>
                              {[...Array(datas?.maxValuesNbr)].map((x, i) => {
                                if (g.values[i]) {
                                  return (
                                    <td key={i} style={{verticalAlign:"middle", textAlign:"center"}}>
                                      {g.values[i]?.label+" %"} ({g.values[i]?.nbr})
                                    </td>
                                  )
                                } else {
                                  return (
                                    <td key={i} style={{verticalAlign:"middle", textAlign:"center"}}>
                                      -
                                    </td>
                                  )
                                }
                              })}
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  ) : (
                    <div style={{display:"flex", justifyContent:"center", marginTop:"30px"}}>
                      <img src={loadingGIF} style={{height:"100px",}}/>
                    </div>
                  )}
                </Container>
              </Box>
            </Box>
          )}

        </Box>
      </Box>
    </>
  )
};

export default EcoleResults;
